import React, { useState } from 'react'
import topbarStyle from './TopBars.module.css'
import { useMediaQuery } from 'react-responsive';

export default function TopBars({ total, onStatusChange, onRecordChange }) {


    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <>
            {isMobile ? (
                <div>

                </div>
            ) : (
                <div className={topbarStyle.topbars}>
                    <div className='row align-items-center'>
                        <div className='col-xl-7'>
                            <div class="row">
                                <div class="col-sm-12">
                                    <p>Number of Records: <strong>{total} </strong></p>
                                </div>
                                { /*<div class="col-sm-6">
                            <select class="ConsolidatedOrdersPage_copformSelect__8mJIP form-select">
                                <option value="-Select-">-Select-</option>
                                <option>20</option>
                            </select>
                        </div> */}
                            </div>
                        </div>
                        <div className='col-xl-5'>
                            <div class="row align-items-center">
                                <label class={`ConsolidatedOrdersPage_coplabels__cKGIn col-sm-4 form-col-label pe-1 ${topbarStyle.maxWidth65}`}>Status:</label>
                                <div class="col-sm-9">
                                    <select class="ConsolidatedOrdersPage_copformSelect__8mJIP form-select" onChange={(e) => onStatusChange(e.target.value)}>
                                        <option value="all">All</option>
                                        <option value="approved">Approved</option>
                                        <option value="draft">Draft</option>
                                        <option value="waiting for approval">Waiting for Approval</option>
                                        <option value="not approved">Not Approved</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {/*<div className='col-xl-2'></div>
                <div className='col-xl-3'>
                    <div className="row align-items-center">
                        <label className="ConsolidatedOrdersPage_coplabels__cKGIn col-sm-3 form-label pe-0">
                            Display
                        </label>
                        <div className="col-sm-9">
                            <select
                            className="ConsolidatedOrdersPage_copformSelect__8mJIP form-select"
                            onChange={(e) => onRecordChange(Number(e.target.value))}
                            defaultValue={0}
                            >
                            <option value="12">12</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div> */}
                    </div>
                </div>
            )}
        </>
    )
}